<template>
  <div class="about6">
    <div>
      <span>開放時間：全天候開放&nbsp;</span>
    </div>
    <div>&nbsp;</div>
    <div>文衡殿地址：台南市龍崎區中坑里中坑3之2號</div>
    <div>&nbsp;</div>
    <div>連絡電話：06-5940050</div>
    <div>&nbsp;</div>
    <div>
      【大眾交通】
      <br />>>從 台南火車站 出發搭乘 公車：
      <br />1.搭乘「大台南公車紅幹線」至關廟轉運站→轉搭紅11、紅12，即可抵達。
      <br />2.搭乘「公路公車8050，臺南火車站 ─ 旗山 ─
      佛光山」，路途中有龍崎文衡殿站，不過班次較少，需留意是否有符合您的時間。
      <br />
      <br />>>從 台南高鐵站 出發搭乘 公車： <br />台南高鐵站
      →搭紅3到關廟轉運站→轉紅11或紅12到龍崎文衡殿
      <br />您可以透過手機APP『台灣公車通』，了解公車行駛時間、狀態等即時訊息
      <br />
      <br />【自行開車】
      <br />關廟交流道下左轉>南雄路二段(19甲)>左轉接中正路(182)直行約15分鐘即可抵達
      <br />
    </div>
    <div>&nbsp;</div>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8738.340876392465!2d120.37771647866634!3d22.949499411407853!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e6e7bf28ea1f9%3A0xbfd560a2ce947118!2z6b6N5bGx5paH6KGh5q6_!5e0!3m2!1szh-TW!2stw!4v1447656702273"
      width="600"
      height="450"
      class="about6-iframe"
      frameborder="0"
      style="border:0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'About6',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped>
@media (max-width: 767px) {
  .about6-iframe {
    width: 100%;
    height: 300px;
  }
}
</style>
